// AdminRoute.tsx
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getUserGroups } from '../utils/AuthUtils'

interface AdminRouteProps {
  children: JSX.Element;
  fallbackPath?: string;
}

const VolunteerRoute = ({ children, fallbackPath = "/unauthorized" }: AdminRouteProps) => {
  const [isVolunteer, setIsVolunteer] = useState<boolean | null>(null);

  useEffect(() => {
    getUserGroups()
      .then((groups) => setIsVolunteer(groups.includes('Staff') || groups.includes('Administrators') || groups.includes('Volunteer')))
      .catch(() => setIsVolunteer(false));
  }, []);

  if (isVolunteer === null) return <div>Loading...</div>;
  if (!isVolunteer) return <Navigate to={fallbackPath} replace />;

  return children;
};

export default VolunteerRoute;
